import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

export const getHonourHistory = async (params: object) => {
  return await GET({ url: Api.honourHistory, params, showError: false })
}
